
import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { filter, tap } from "rxjs";
import { SideMenu } from "../../header/header.type";
import { User } from "@teammood/shared/util/user";
import { DialogService } from "@teammood/shared/ui/dialog";
import { TmContactUsDialogComponent } from "../contact-us/contact-us-dialog.component";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { MatTooltip } from "@angular/material/tooltip";
import { MatBadge } from "@angular/material/badge";
import { HeaderService } from "../../header/header.service";

@Component({
    selector: 'side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        RouterLink,
        RouterLinkActive,
        MatTooltip,
        MatBadge
    ]
})
export class TmSideMenuComponent implements OnInit {

    @Input() sideHeader: SideMenu;
    @Input() user: User;

    constructor(
        private dialogService: DialogService,
        private headerService: HeaderService,
    ) {}

    ngOnInit(): void {
        this.headerService.getTriageCount()
            .pipe(
                filter(() => !!this.sideHeader && !!this.sideHeader.respondMenu),
                tap(count => {
                    const triageMenuEntry = this.sideHeader.respondMenu.items.find(entry => entry.name === 'triage');
                    if (triageMenuEntry){
                        triageMenuEntry.counter = count;
                    }
                })
            )
            .subscribe();
    }

    protected async openContactUsDialog(){
        await this.dialogService.open(TmContactUsDialogComponent, {
            width: '100%',
            maxWidth: '490px',
            enterAnimationDuration: 0,
            exitAnimationDuration: 0,
            data: {
                user: this.user
            }
        });

    }
}